import { AxiosPromise } from "axios";
import {
  IAnaliseVacancyRequest,
  IAnaliseVacancyResponse,
  ICandidateListRequest,
  ICandidateListResponse,
  IExportAnalyticsRequest,
  IRecruiterAnalyticsRequest,
  IRecruitersAnalytics,
  ISingleVacancyAnalise,
} from "./types";
import { axiosInstance } from "../instance";

export const getAnaliseVacancy = (
  params: IAnaliseVacancyRequest
): AxiosPromise<IAnaliseVacancyResponse> =>
  axiosInstance.get(`/analytics/vacancy-stages`, {
    params: { ...params, channel_id: params.department_id ? null : params.channel_id },
  });
export const getVacancies = (
  params: IAnaliseVacancyRequest
): AxiosPromise<ISingleVacancyAnalise[]> =>
  axiosInstance.get(`/analytics/vacancies`, { params: params });

export const getCandidateList = (
  params: ICandidateListRequest
): AxiosPromise<ICandidateListResponse> =>
  axiosInstance.get(`/analytics/candidates`, { 
    params: { ...params, department_id: params.department_id ? params.department_id : null, channel_id: params.department_id ? null : params.channel_id }
  });

export const getAnaliseRecruiter = (
  params: IRecruiterAnalyticsRequest
): AxiosPromise<IRecruitersAnalytics[]> =>
  axiosInstance.get(`/analytics/recruiters`, { params: {...params, channel_id: params.department_id ? null : params.channel_id} });

export const exportAnalytics = (
  params: IExportAnalyticsRequest
): AxiosPromise<Blob> =>
  axiosInstance.get(`/analytics/candidates-export`, {
    params: params,
    responseType: "blob",
  });
